import React from "react";
import PropTypes from "prop-types";
import NavTabs from "~components/NavTabs";


const ReflexLayout = ({ children, customTabs }) => {
  const url = globalThis.location.pathname === `/reflex/historico` ? `/reflex/mes-atual` : globalThis.location.pathname
  const tabs = customTabs ?? [
    { name: "RESULTADOS", link: url },
    { name: "HISTÓRICO", link: "/reflex/historico" },
  ];
  return (
    <div data-testid="layout-container" className="container ">
      <NavTabs navs={tabs} />

      {children}
    </div>
  );
};

ReflexLayout.propTypes = {
  children: PropTypes.node,
  customTabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};

export default ReflexLayout;
